import { POST } from '../../api';
import { EditProfileRequest } from './editprofilerequest';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { BaseContext } from '../../../../utils/basecontext';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { UpdateProfileFeatures } from '../../../updateprofilefeatures';

export class EditProfileAPI extends SixdeeCRBTAPI<EditProfileRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/edit-profile
        return "edit-profile";
    }

    getHttpHeaders():string
    {
       let baseHeaders = super.getHttpHeaders();
       let combinedHeaders : any;

       if(this.getRequest().getEditProfileRequest().getIdentifier() === UpdateProfileFeatures.IdentifierUpdateProfilePic)
       {
           let editProfileHeaderForProfilePic = {
            "Content-Type" : "abc"
           } as any; 
           combinedHeaders = Object.assign(editProfileHeaderForProfilePic, baseHeaders);
           return combinedHeaders;
       }
       else
       {
           return baseHeaders;
       }
    }

    getRequestData()
    {
        if(this.getRequest().getEditProfileRequest().getIdentifier() === UpdateProfileFeatures.IdentifierUpdateUsername)
        {
          return "clientTxnId=21042020"+"&"+
               "identifier=" + this.getRequest().getEditProfileRequest().getIdentifier() +"&"+
               "language="+ this.getRequest().getEditProfileRequest().getLanguage() +"&"+
               "msisdn=" + this.getRequest().getEditProfileRequest().getMsisdn() +"&"+
               "servType="+ this.getRequest().getEditProfileRequest().getServType()+"&"+
               "name="+ this.getRequest().getEditProfileRequest().getUpdatableServiceValue();
        }
        else if(this.getRequest().getEditProfileRequest().getIdentifier() === UpdateProfileFeatures.IdentifierUpdateProfilePic)
        {
          return "clientTxnId=21042020"+"&"+
               "identifier=" + this.getRequest().getEditProfileRequest().getIdentifier() +"&"+
               "language="+ this.getRequest().getEditProfileRequest().getLanguage() +"&"+
               "msisdn=" + this.getRequest().getEditProfileRequest().getMsisdn() +"&"+
               "servType="+ this.getRequest().getEditProfileRequest().getServType()+"&"+
               "previewImage ="+ this.getRequest().getEditProfileRequest().getUpdatableServiceValue();
        }
        else if(this.getRequest().getEditProfileRequest().getIdentifier() === UpdateProfileFeatures.IdentifierUpdateCategories)
        {  
            return "clientTxnId=21042020"+"&"+
               "identifier=" + this.getRequest().getEditProfileRequest().getIdentifier() +"&"+
               "language="+ this.getRequest().getEditProfileRequest().getLanguage() +"&"+
               "msisdn=" + this.getRequest().getEditProfileRequest().getMsisdn() +"&"+
               "servType="+ this.getRequest().getEditProfileRequest().getServType()+"&"+
               "categoryId="+ this.getRequest().getEditProfileRequest().getUpdatableServiceValue();
        }
        else
        {
           return "";
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/myaccount/editprofile/editprofileapi.tsx